<div class="kt-portlet">
	<kt-portlet-header [sticky]="false" [title]="'Cold Brew'" [class]="'kt-portlet__head--lg'">
	</kt-portlet-header>
	<div class="kt-portlet__body">
		<div class="cold-brew col-xl-10 col-md-12 col-sm-12 mt-3 mx-auto">
			<div class="cold-brew__error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</div>

			<ng-container *ngIf="isLoading">
				<span class="cold-brew__sr-only" role="status">Loading the paired cold brew fridge</span>
				<div class="cold-brew__card" aria-hidden="true">
					<div class="cold-brew__row">
						<div class="cold-brew__skeleton-stack">
							<span class="cold-brew__skeleton" style="width: 130px; height: 10px"></span>
							<span class="cold-brew__skeleton" style="width: 200px; height: 16px"></span>
							<span class="cold-brew__skeleton" style="width: 160px; height: 10px"></span>
						</div>
						<span class="cold-brew__skeleton cold-brew__skeleton--pill"></span>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="!isLoading && result">
				<ng-container *ngIf="result.device">
					<div class="cold-brew__card">
						<div class="cold-brew__row">
							<div>
								<span class="cold-brew__label">Paired cold brew fridge</span>
								<a class="cold-brew__value" [routerLink]="['/cold-brew', result.device.haha_market_id]">{{ fridgeName }}</a>
								<span class="cold-brew__muted">
									Haha {{ result.device.haha_market_id }}<ng-container *ngIf="result.assignment?.campus_name"> · {{ result.assignment.campus_name }}</ng-container>
								</span>
							</div>
							<span class="cold-brew__pill" *ngIf="result.device.is_online !== null" [class.cold-brew__pill--on]="result.device.is_online">
								{{ result.device.is_online ? 'Online' : 'Offline' }}
							</span>
						</div>
						<div class="cold-brew__notice cold-brew__notice--warn" role="alert" *ngIf="result.pairing?.broken">
							<p>This pairing is broken: the fridge and this machine are on different campuses. End it from the fridge’s page.</p>
						</div>
					</div>
					<p class="cold-brew__muted">Pairing is managed from the fridge’s page in Cold Brew.</p>
				</ng-container>

				<div class="cold-brew__card" *ngIf="!result.device">
					<p class="cold-brew__value">No cold brew fridge is paired with {{ machineName || 'this machine' }}</p>
					<p class="cold-brew__muted">
						To pair one, open the fridge in <a routerLink="/cold-brew">Cold Brew</a> and choose this machine. The fridge must be on the same campus.
					</p>
				</div>
			</ng-container>
		</div>
	</div>
</div>
